import AbstractController from '../src/services/ControllersRepository/AbstractController';
import PurchaseUpdateForm from '@views/purchases/PurchaseUpdateForm';
import PurchaseCreateForm from '@views/purchases/PurchaseCreateForm';

export default class Purchases extends AbstractController {
    protected controllerName = 'Purchases';

    protected getDefaultCreateFormComponent() {
        return PurchaseCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return PurchaseUpdateForm;
    }
}
